import {AuthLoadingScreen} from '@sollapay/web-core';

import {LoginPosterBackground} from './LoginPosterBackground';

import type {FC} from 'react';

export const LoginFormSkeleton: FC = () => (
  <AuthLoadingScreen background={<LoginPosterBackground />} />
);
